import { useEffect, useState } from "react";
import { Reveal } from "@/lib/motion";
import { EVENT } from "@/lib/site";

const target = Date.parse(EVENT.eventStart);

function parts() {
  const left = Math.max(0, target - Date.now());
  const total = Math.floor(left / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor(total / 3600) % 24,
    minutes: Math.floor(total / 60) % 60,
    seconds: total % 60,
    done: left === 0,
  };
}

export default function Countdown() {
  const [t, setT] = useState(parts());
  useEffect(() => {
    const timer = setInterval(() => setT(parts()), 1000);
    return () => clearInterval(timer);
  }, []);
  const cell = (value, label, testid) => (
    <div className="text-center">
      <strong data-testid={testid} className="block font-display text-4xl tabular-nums sm:text-5xl">
        {String(value).padStart(2, "0")}
      </strong>
      <span className="text-[10px] font-bold tracking-[0.2em] opacity-70">{label}</span>
    </div>
  );
  return (
    <section data-testid="countdown-band" className="bg-[#d7ef8b]" aria-label="Countdown to OFIC 2026">
      <div className="wrap flex flex-col items-center justify-between gap-8 py-12 lg:flex-row lg:py-16">
        <Reveal>
          <span className="eyebrow">The organic community meets in</span>
          <h2 className="mt-2 font-display text-3xl sm:text-4xl">
            A date with <em className="italic">possibility.</em>
          </h2>
          <p className="mt-2 text-sm font-bold opacity-80">11 December 2026 · Mumbai</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex items-start gap-4 sm:gap-6" role="timer" aria-label="Time until 11 December 2026, midnight India Standard Time">
            {cell(t.days, "DAYS", "countdown-days")}
            <b className="mt-2 text-2xl opacity-40">:</b>
            {cell(t.hours, "HOURS", "countdown-hours")}
            <b className="mt-2 text-2xl opacity-40">:</b>
            {cell(t.minutes, "MINUTES", "countdown-minutes")}
            <b className="mt-2 text-2xl opacity-40">:</b>
            {cell(t.seconds, "SECONDS", "countdown-seconds")}
          </div>
          <p className="mt-3 text-right text-[11px] font-bold tracking-[0.14em] opacity-60">
            {t.done ? "EVENT DAY · 11 DECEMBER 2026" : "COUNTING DOWN TO EVENT DAY · IST"}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
